import React from 'react';
import { withTranslation } from 'react-i18next';
import ArrowRight from '../../images/arrow-right.png';
import Parent from '../parent';
import { constants } from "../constants/constants";
import {BllinkLogger} from "../utils/bllink_loggers";

export class BackToPersonalDetails extends Parent {
    tenantDetailsUrl(props) {
        if (props.isViewedAsManager) {
            return `/${constants.pages.tenantDetailsManagerUrl}/${props.buildingID}`
        } else {
            return `/${constants.pages.tenantDetailsUrl}/${props.buildingID}`
        }
    }

    onBackLinkClick = evt => {
        evt.preventDefault();
        const isUrl = true;
        this.props.onNextBackChange(this.tenantDetailsUrl(this.props), isUrl);
    }

    render() {
        const {t} = this.props;
        BllinkLogger.info(`BackToPersonalDetails `, this.props);
        
        return (
            <p className="right-botton-p">
                <a
                    className="js-tenant-details"
                    href={this.tenantDetailsUrl(this.props)}
                    onClick={this.onBackLinkClick}
                >
                    <img alt='return_to_details' src={ArrowRight} />
                    {t('payments.update_personal_details')}
                </a>
            </p>
        )
    }
}

export default withTranslation()(BackToPersonalDetails);
